module.exports = __webpack_public_path__ + "icomoon.svg?78ac7379697f3b0a9d083a0984193427";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/icomoon/icomoon.svg?-rdnm34
// module id = 918
// module chunks = 27